import React from 'react';
import Breadcrumb from '../../components/breadcrumb/breadcrumb';
import Sidebar from '../../components/sidebar/sidebar';
import DetailedProduct from '../../components/product/detailedProduct';
import DetailsHeading from '../../components/detailsHeading/detailsHeading';
import CardIngredients from '../../components/card/cardIngredients';
import CardNutritional from '../../components/card/cardNutritional';
//import SuggestedProductsHeading from '../../components/product/suggestedProductsHeading';
//import DiscoverProduct from '../../components/product/discoverProduct';
import HorizontalMenu from '../../components/sidebar/horizontalMenu';
import RotatingDiv from '../../components/rotatingDiv/rotatingDiv';

//import product images
import toranja from '../../images/products/toranja.png';
//import fig from '../../images/products/fig.png';
//import blueberry from '../../images/products/blueberry.png';

function Toranja() {
    /*const suggestions = [
        {
            name: 'Doce de Figo Pingo de Mel',
            photo: fig,
            link: 'https://www.floryptus.pt/fig',
            className: 'floryptus-link',
        },
        {
            name: 'Doce de Mirtilo',
            photo: blueberry,
            link: '/originalberry',
            className: 'floryptus-link',
        },
    ];*/

    return (
        <>
            <div className="horizontal-menu">
                <HorizontalMenu />
            </div>
            <div className="breadcrumb-container">
                <Breadcrumb
                    home="Home"
                    section="Produtos"
                    category="Doces de Physalis"
                    name="Toranja"
                ></Breadcrumb>
            </div>
            <div className="product-details-grid">
                <div className="sidebar-menu padding-top30 padding-left50">
                    <Sidebar />
                </div>
                <DetailedProduct
                    photo={toranja}
                    name="Toranja"
                    color="red-text"
                    category="Doces de Physalis"
                    description="Combinação excelente para quem não aprecia tanto o 'doce',
                pois neste doce com a adição da toranja,
                realça com moderada intensidade o amargo muito característico desta fruta,
                o que o torna excelente para em torradas ou bolachas se fazer acompanhar por um chá."
                    weight="Frasco de 245g"
                    link="/contacts"
                    buttonColor="btn--toranja"
                    buttonText="Online"
                ></DetailedProduct>
                <div className="details">
                    <div className="details-title">
                        <DetailsHeading
                            text="Detalhes"
                            type="toranja"
                        ></DetailsHeading>
                    </div>
                    <div className="cards">
                        <div className="card-ingridients-container">
                            <CardIngredients
                                percentage="60%"
                                sugar="yes"
                                salt="yes"
                                ingredient="Toranja Star Ruby"
                            ></CardIngredients>
                            <RotatingDiv>
                                <div className="svg-toranja stripes-pattern-container"></div>
                            </RotatingDiv>
                        </div>
                        <div className="card-nutritional-container mb-100">
                            <CardNutritional
                                energy="1187 kj / 280 kcal"
                                lipids="0.46 g"
                                saturados="0.02 g"
                                hydrates="65.90 g"
                                sugars="56.80 g"
                                fiber="2.75 g"
                                proteins="1.61 g"
                                salt="0.42 g"
                            ></CardNutritional>
                            <RotatingDiv>
                                <div className="svg-toranja stripes-pattern-container2"></div>
                            </RotatingDiv>
                        </div>
                    </div>
                </div>
                {/*
                <div className="suggestions-heading">
                    <SuggestedProductsHeading
                        question="Não resiste a doces de fruta?"
                        answer="Deixe-se levar:"
                        color="red-text"
                    ></SuggestedProductsHeading>
                </div>
                <div className="discover-section-grid">
                    {suggestions.map((discoverProduct, idx) => (
                        <DiscoverProduct
                            key={idx}
                            discoverProduct={discoverProduct}
                        />
                    ))}
                </div>
                    */}
            </div>
        </>
    );
}

export default Toranja;
